// extracted by mini-css-extract-plugin
export default {"iconWrapper":"MaskActionButton_iconWrapper__2r1ZT"};